import './style.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import ClassNames from 'classnames';
import $ from 'jquery';
import _ from 'lodash';
import {Link} from 'react-router';

import {displayDateFormat} from 'app/lib/format';
import ButtonGroup from 'routes/app/components/ButtonGroup';
import {Header, Page, PageMain} from 'routes/app/components';
import {Row, Col} from 'routes/app/components';
import {Button, Select, Input, FreeTextSelect, Modal} from 'routes/app/components';
import {Chip} from '../VisitOverview/Visit/VisitStatus';
import {TimeSlotPicker} from '../TimeSlotPicker';
import UnitsTable from './UnitsTable';
import UnitForm from '../UnitForm/UnitForm';

const VisitForm = ({
    getDocs, activeUnit, formatMessage, isEdit, isSubmitting, isLoading, unitVerification, chassisTypes,
    fields:{status, licensePlate, canSubmit, units, slotEta, dom, timeslot, transId, chassisPlate, chassisType, trac, ownerTransId},
    addUnit, saveUnit, removeUnit, editUnit, dateChanged, onTimeSlotDateChange, saveDraft, submitVisit, verifyUnit, onOpenUnitForm, onCloseUnitForm, saveGood, deleteGood,
    saveDoc, deleteDoc, onOpenTimeSlot,
    packUnity, docTypes, unitKinds, terminals, timeSlots, timeSlotConfig, transCompList, licensePlates, goods, docs, skipGoodsDocsEntry
}) => {

    let _unitWrapper;
    const mainTitle = isEdit ? <span><FormattedMessage id="visit.form.edit.mainTitle"/> {trac.value}</span> :
        <FormattedMessage id="visit.form.new.mainTitle"/>;
    const isEditUnit = activeUnit && !!activeUnit.trac.value;
    const unitWrapperClasses = {
        'unit-wrapper': !isEditUnit,
        'unit-wrapper--edit': isEditUnit
    };

    const showUnitForm = (trac) => {
        let u = $(_unitWrapper);
        u.show();
        onOpenUnitForm(activeUnit);
        setTimeout(() => {
            u.removeClass('initial');
        }, 15);
    };

    const submitUnitForm = (close) => {
        saveUnit();
    };

    const cancelUnitForm = () => {
        closeBubble();
        if (!isEditUnit) {
            units.removeField(units.length - 1);
        }
        onCloseUnitForm();
    };

    const closeBubble = () => {
        let u = $(_unitWrapper);
        u.fadeOut(() => {
            //     u.addClass('initial');
        });
    };

    const getDomainName = (code) => {
        const terminal= code && _.find(terminals, (t) => {
            return t.code.toLowerCase().trim() === code.toLowerCase().trim()
        });

        return terminal ? terminal.name : '';
    };

    return (
        <section className="visit__form">
            <Header>
                <h1><FormattedMessage id="visit.form.pageTitle"/> {trac.value}</h1>
            </Header>
            <Page>
                {isLoading ? <PageMain title={mainTitle} full>...</PageMain> :

                    <PageMain title={mainTitle} full>

                        <Chip status={status.value}/>

                        {terminals.length > 1 && !trac.value &&
                        <Row>
                            <Select s={12} m={6} id="dom" label={<FormattedMessage id="visit.terminal" />}
                                    options={terminals} optionValue="code" optionLabel="name"
                                {...dom}
                            />
                        </Row>
                        }
                        {terminals.length > 1 && trac.value &&
                        <Row>
                            <Input s={12} m={6} value={getDomainName(dom.value)}
                                   label={<FormattedMessage id="visit.terminal" />} readOnly/>
                            <input type="hidden" {...dom} readOnly/>
                        </Row>
                        }
                        {terminals.length === 1 &&
                        <input type="hidden" {...dom} readOnly/>
                        }

                        <Row>
                            <Input s={12} m={6} type="date" id="slotEta" label={<FormattedMessage id="label_date" />}
                                   placeholder={formatMessage({id:'input.help.date'})}
                                   format={displayDateFormat}
                                   datePickerOptions={{max:new Date(new Date().getTime() + ((24 * 60 * 60 * 1000) * 7))}}
                                {...slotEta} onChange={dateChanged} />

                            {slotEta.value &&
                            <TimeSlotPicker s={12} m={6}
                                            id="timeslot" label={<FormattedMessage id="visit.timeslot" />}
                                            placeholder={formatMessage({id:'input.help.timeslot'})}
                                            translateFn={formatMessage}
                                            onDateChange={onTimeSlotDateChange}
                                            config={timeSlotConfig}
                                            data={timeSlots}
                                            onOpen={onOpenTimeSlot}
                                {...timeslot} />
                            }
                        </Row>

                        {slotEta.value &&
                        <Row>

                            <Select s={12} m={6} id="transId" label={<FormattedMessage id="visit.transName" />}
                                    options={transCompList} optionValue="code" optionLabel="name"
                                {...transId} />

                            {licensePlates.length ?
                                <FreeTextSelect s={12} m={6}
                                                id="licensePlate" label={<FormattedMessage id="visit.licenseplate" />}
                                                options={licensePlates}
                                    {...licensePlate}/>
                                :
                                <Input s={12} m={6} id="licensePlate"
                                       label={<FormattedMessage id="visit.licenseplate" />} {...licensePlate}
                                       onChange={(e) => {
                                           const value = e.target.value.toUpperCase();
                                           return licensePlate.onChange(value.toUpperCase().replace(/[^A-Z0-9]/g, '') || " ");
                                       }}
                                       value={licensePlate.value ? licensePlate.value.trim() : null}/>
                            }

                        </Row>
                        }

                        {slotEta.value &&
                        <Row>
                            {chassisTypes.length > 1 &&
                            <Select
                                s={6} m={6}
                                id="chassisType"
                                label={<FormattedMessage id="visit.chassisType"/>}
                                options={chassisTypes}
                                optionValue="id"
                                optionLabel="descr"
                                {...chassisType}
                            />
                            }
                            <Input
                                s={6} m={6}
                                id="chassis"
                                label={<FormattedMessage id="visit.chassis" />}
                                {...chassisPlate}
                            />
                        </Row>
                        }

                        {slotEta.value && !trac.value &&
                        <Row className="visit__units__notification"><Col s={12}><FormattedMessage
                            id="visit.units.table.saveFirst"/></Col></Row>}

                        {slotEta.value && trac.value &&
                        <UnitsTable units={units} addUnit={addUnit} editUnit={editUnit} formatMessage={formatMessage}
                                    removeUnit={removeUnit} showUnit={showUnitForm}/>}

                        <input type="hidden" {...trac} />
                        <input type="hidden" {...status} />
                        <input type="hidden" {...ownerTransId} />

                        {slotEta.value &&
                        <Row>
                            <Col s={12}>
                                <ButtonGroup>

                                    <Button waves="light"
                                            toast="Visit saved"
                                            onClick={saveDraft}
                                            disabled={isSubmitting}
                                    >
                                        <FormattedMessage id="visit.form.saveDraft"/>
                                    </Button>

                                    {canSubmit.value ?
                                        <Modal
                                            header={formatMessage({id:'visit.form.submit.header'})}
                                            onClickAgree={() => submitVisit({trac: trac.value})}
                                            textDisagree={formatMessage({id:'visit.form.submit.cancel'})}
                                            textAgree={formatMessage({id:'visit.form.submit.agree'})}
                                            trigger={
                                        <Button waves="light" className="btn-warning"
                                                disabled={isSubmitting}
                                                flat ><FormattedMessage id="visit.form.submit" /></Button>
                                    }>
                                            <p>{formatMessage({id: 'visit.form.submit.confirm'})}</p>
                                        </Modal> : <Button disabled><FormattedMessage id="visit.form.submit"/></Button>
                                    }

                                    <Link to="/visits"><Button className="right" flat><FormattedMessage
                                        id="visit.form.cancel"/></Button></Link>

                                </ButtonGroup>
                            </Col>
                        </Row>
                        }

                    </PageMain>
                }

                {activeUnit &&
                <section className={ClassNames(unitWrapperClasses, {initial:false, content:true})}
                         ref={(c) => _unitWrapper = c}>
                    <header className="header">
                        <div className="container">
                            <h1>
                                <Button
                                    onClick={cancelUnitForm} flat>
                                    <i className="material-icons">arrow_back</i>
                                </Button>
                                {isEditUnit ?
                                    <span><FormattedMessage
                                        id="unit.modal.header.isEdit"/> {activeUnit.trac.value}</span> :
                                    <FormattedMessage id="unit.modal.header.isNew"/>}
                            </h1>
                        </div>
                    </header>

                    <UnitForm className="unit-form container"
                              onCancel={cancelUnitForm}
                              onSubmit={submitUnitForm}
                              visitDate={slotEta.value}
                              visitLicensePlate={licensePlate.value}
                              unitKinds={unitKinds}
                              packUnity={packUnity}
                              docTypes={docTypes}
                              verifyUnit={()=>verifyUnit(activeUnit)}
                              unitVerification={unitVerification}
                              goods={goods}
                              saveGood={saveGood}
                              deleteGood={deleteGood}
                              docs={docs}
                              saveDoc={saveDoc}
                              deleteDoc={deleteDoc}
                              getDocs={getDocs}
                              vtrac={trac.value}
                              skipGoodsDocsEntry={skipGoodsDocsEntry}
                        {...activeUnit} />
                </section>
                }

            </Page>
        </section>
    );
};

VisitForm.propTypes = {
    getDocs: PropTypes.func,
    activeUnit: PropTypes.object,
    addUnit: PropTypes.func,
    dateChanged: PropTypes.func,
    onTimeSlotDateChange: PropTypes.func,
    editUnit: PropTypes.func,
    saveUnit: PropTypes.func,
    saveGood: PropTypes.func,
    deleteGood: PropTypes.func,
    saveDoc: PropTypes.func,
    deleteDoc: PropTypes.func,
    fields: PropTypes.object,
    formatMessage: PropTypes.func,
    onOpenUnitForm: PropTypes.func,
    onCloseUnitForm: PropTypes.func,
    onOpenTimeSlot: PropTypes.func,
    isEdit: PropTypes.bool,
    isLoading: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    licensePlates: PropTypes.array,
    packUnity: PropTypes.array,
    docTypes: PropTypes.array,
    removeUnit: PropTypes.func,
    saveDraft: PropTypes.func,
    submitVisit: PropTypes.func,
    verifyUnit: PropTypes.func,
    terminals: PropTypes.array,
    timeSlots: PropTypes.object,
    timeSlotConfig: PropTypes.object,
    transCompList: PropTypes.array,
    unitKinds: PropTypes.array,
    unitVerification: PropTypes.object,
    goods: PropTypes.array,
    docs: PropTypes.array,
    chassisTypes: PropTypes.array.isRequired,
    skipGoodsDocsEntry: PropTypes.bool.isRequired
};

export default VisitForm;
